import { Container, Graph, SectionTitle, Stats } from '@sloyd/ui';
import { graphs } from './ContentUsage.data';
import { Graphs, Wrapper } from './ContentUsage.style';

export type ContentUsageProps = {
  settings: ISettings;
  callbacks: {
    onChange: (_change: Json, allData: Json) => void;
  };
};

export function ContentUsage(props: ContentUsageProps) {
  const { settings, callbacks } = props;

  function renderGraph(graph: Json) {
    return <Graph key={graph.id} {...graph} />;
  }

  function renderGraphs() {
    return graphs.map((graph: Json) => renderGraph(graph));
  }

  return (
    <Wrapper>
      <Container sizegraphs='xs'>
        <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Usage'>
          Check your <strong>usage</strong> here.
        </SectionTitle>
        <Stats />
        <Graphs>{renderGraphs()}</Graphs>
      </Container>
    </Wrapper>
  );
}

export default ContentUsage;
